<template>
  <div class="submit-nav">
    <div class="navbar is-fixed-bottom is-dark">
      <div class="container" :style="{ maxWidth: width + 'px !important' }">
        <div class="navbar-start">
          <div class="navbar-item">
            <div class="buttons">
              <b-button
                  type="is-primary" class="has-text-weight-bold"
                  icon-left="twitter" icon-pack="fab"
                  @click="submit"
                  :disabled="!submitActive"
                  :title="submitTitle">{{ submitText }}</b-button>
              <b-button
                  outlined
                  @click="schedule"
                  :active="this.$store.getters.canPostThread"
                  :disabled="!this.$store.getters.canPostThread"
                  :title="`${$modifierKeyEncoded}+Shift+S: Schedule your thread.`"
                  icon-left="clock"
                  type="is-light">Schedule</b-button>
            </div>
          </div>
        </div>
        <div class="navbar-end" v-if="submitStatus === 'error'">
          <div class="navbar-item has-text-light">
            Next fix:&nbsp; <a class="has-text-warning-light is-underlined ml-1" @click.prevent="jumpToError">
              Tweet #{{ $store.getters.tweetIndexById($store.getters.firstTweetError.id) + 1 }} {{ $store.getters.firstTweetError.error }}
            </a>
          </div>
        </div>
      </div>
      <b-modal
          v-model="modalActive"
          scroll="keep"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal
          :destroy-on-hide="true">
        <template #default="props">
          <submit-modal :active="modalActive" :scheduling="modalType === 'schedule'" @close="props.close"></submit-modal>
        </template>
      </b-modal>

    </div>
  </div>
</template>

<script>
import SubmitModal from "./modals/SubmitModal";

export default {
  name: "SubmitNav",
  components: {SubmitModal},
  props: {
    width: {
      type: Number,
      default: 640
    }
  },
  data() {
    return {
      modalActive: false,
      modalType: 'post'
    }
  },
  computed: {
    // watch triggers
    postThread() {
      return this.$store.state.app.triggers.postThread
    },
    scheduleThread() {
      return this.$store.state.app.triggers.scheduleThread
    },

    // returns one of for status types on whether thread can be posted
    submitStatus() {
      if (this.$store.getters.activeThreadEmpty) {
        return 'empty'
      } else if (!this.$store.getters.tweetThreadIsValid) {
        return 'error'
      } else if (!this.$store.getters.isLoggedIn) {
        return this.$store.state.auth.accounts.length ? 'stealth' : 'noauth'
      }
      return 'active'
    },

    submitTitle() {
      return {
        active: `${this.$modifierKeyEncoded}+Shift+Enter: Review and post thread to Twitter`,
        error: 'Correct your thread errors before submitting!',
        empty: 'Start typing your thread to get started!',
        stealth: 'Click to select an account in order to post a thread',
        noauth: 'Click to sign in to Twitter so you can post a thread'
      }[this.submitStatus]
    },
    submitActive() {
      return {
        active: true,
        empty: false,
        error: false,
        stealth: true,
        noauth: true
      }[this.submitStatus]
    },
    submitText() {
      return {
        active: 'Post thread now',
        empty: 'Post thread now',
        error: 'Fix errors',
        stealth: 'Select an account',
        noauth: 'Sign in to post!'
      }[this.submitStatus]
    },
  },
  watch: {
    postThread(val) {
      if (val) {
        this.$store.commit('clearTrigger', 'postThread')
        this.submit()   // we delegate what actually to do in this method
      }
    },
    scheduleThread(val) {
      if (val) {
        this.$store.commit('clearTrigger', 'scheduleThread')
        if (this.$store.getters.canPostThread) {
          this.schedule()
        }
      }
    }
  },

  methods: {
    submit() {
      if (this.submitStatus === 'error') {
        // while we disable the button click, this might be called on a trigger
        this.jumpToError()

      } else if (this.submitStatus === 'active') {
        this.modalType = 'post'
        this.modalActive = true

      } else if (this.submitStatus === 'stealth') {
        this.$store.commit('setTrigger', 'selectAccount')

      } else if (this.submitStatus === 'noauth') {
        this.$store.commit('setTrigger', 'signIn')

      }
    },
    schedule() {
      if (this.$store.getters.canPostThread) {
        this.modalType = 'schedule'
        this.modalActive = true
      }
    },

    jumpToError() {
      this.$store.dispatch('focusOnTweet',
          this.$store.getters.tweetIndexById(this.$store.getters.firstTweetError.id)
      )
    }
  },
}
</script>


<style lang="scss" scoped>

ul {
  max-height: 5rem;
  overflow-y: auto;
}

</style>
